import { Typography } from "@mui/material";
import * as DecisionBaseModal from "components/pages/game/decision-modals/DecisionBaseModal";
import React from "react";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const Component: React.FC<Props> = ({ isOpen, onClose }) => {
  const renderContent = () => {
    return (
      <div>
        <Typography variant="body1">
          Are you sure you want to <strong>mulligan your corporation</strong>?
        </Typography>
        <Typography variant="body1" component="em">
          You will be stuck with whatever corporation you draw.
        </Typography>
      </div>
    );
  };

  return (
    <DecisionBaseModal.Component
      content={renderContent()}
      isOpen={isOpen}
      onClose={onClose}
      ActionData={{}}
      ActionId="MULLIGAN_CORP"
      DecisionId="STARTING_HAND"
    />
  );
};

Component.displayName = "MulliganCorpModal";
